// ISDP CUSTOM: handles the Okta redirect. The DevSecOps Hub Okta app redirects to http://localhost:4280/
// (app root) with ?code&state. This component (mounted app-wide) detects that, exchanges the code via the
// BFF, stores the opaque session id, cleans the URL, and forwards the user back to the Self
// Service page they were heading for (see takeDsoReturnPath).
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { configApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import { setDsoSession, takeDsoReturnPath } from './useDevSecOpsAuth';

export const DevSecOpsAuthCallback = () => {
  const config = useApi(configApiRef);
  const { fetch } = useApi(fetchApiRef);
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) return;
    ran.current = true;

    (async () => {
      const base = `${config.getString('backend.baseUrl')}/api/devsecops`;
      try {
        const resp = await fetch(`${base}/auth/exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state }),
        });
        const data = await resp.json();
        if (resp.ok && data.sessionId) setDsoSession(data.sessionId);
        // on failure, fall through to the finally block which lands the user on /self-service
      } catch (e) {
        // swallow exchange errors; the finally block still cleans the URL and navigates
      } finally {
        // strip ?code&state from the URL, then return the user to whatever Self Service
        // page they were heading for (Create by default) rather than the hub's own default
        // section, which is "My Projects" and is not where anyone starts.
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(takeDsoReturnPath());
      }
    })();
  }, [config, fetch, navigate]);

  return null;
};
